import { useEffect, useState } from "react";
import { isBrowser } from "../util/env-utils";

interface LisAvatarResponse {
  avatar_image: string;
  description: string;
}

export interface AvatarLis {
  url: string;
  description: string;
}

const DEFAULT_AVATAR: AvatarLis = {
  url: `/images/avatar-lis.png`,
  description:
    "Ilustração da LIS, assistente virtual, com cabelo cacheado, faixa colorida no cabelo, sorriso aberto e camisa azul com a bandeira de Pernambuco estampada ao centro.",
};

const getBaseUrl = () => {
  const proxyEndpoint = isBrowser
    ? window.PROXY_ENDPOINT
    : process.env.PROXY_ENDPOINT;
  const cmsProxyPath =
    (isBrowser ? window.CMS_PROXY_PATH : process.env.CMS_PROXY_PATH) ||
    "xvia-cms-backend";

  if (proxyEndpoint && cmsProxyPath) {
    return `${proxyEndpoint}/api/${cmsProxyPath}`;
  }

  return "";
};

export const useAvatarLis = (): AvatarLis => {
  const [avatarLis, setAvatarLis] = useState<AvatarLis>(DEFAULT_AVATAR);

  useEffect(() => {
    fetchAvatarLis();
  }, []);

  const fetchAvatarLis = async () => {
    try {
      const response = await fetch(`${getBaseUrl()}/items/lis_avatar`, {
        method: "GET",
      });
      const { data }: { data: LisAvatarResponse } = await response.json();

      if (data && data.avatar_image) {
        setAvatarLis({
          url: `${getBaseUrl()}/assets/${data.avatar_image}`,
          description: data.description,
        });
      }
    } catch (error) {
      console.error("Erro ao buscar avatar da Lis:", error);
      setAvatarLis(DEFAULT_AVATAR);
    }
  };

  return avatarLis;
};
